import { useTheme } from '@app/styled';
import { ErrorIcon, Flex, Popover } from '@lokalise/louis';

import { PopoverText } from '../../StyleGuideRow/style';
import { IconContainer, SyncButtonContainer, TextContainer } from '../styles';

export const ContentErrorStateButton = () => {
    const theme = useTheme();

    return (
        <Popover
            content={
                <PopoverText>
                    Failed to extract content of the style guide. Please ensure that file is not corrupted, contains
                    text content and try syncing again.
                </PopoverText>
            }
            triggerEvent="hover"
            withArrow
        >
            <SyncButtonContainer $hasError $disableCursor>
                <Flex align="center" wrap="nowrap">
                    <IconContainer align="center" justify="center">
                        <ErrorIcon color={theme.color.background.action.danger.default} size="16px" />
                    </IconContainer>
                    <TextContainer>Content issues</TextContainer>
                </Flex>
            </SyncButtonContainer>
        </Popover>
    );
};

export default ContentErrorStateButton;
